import React from 'react';
import storageService from '../../services/storageService';

interface UseProtectedStorageUrlResult {
  objectUrl: string | null;
  isLoading: boolean;
  hasError: boolean;
}

export const useProtectedStorageUrl = (path?: string): UseProtectedStorageUrlResult => {
  const [objectUrl, setObjectUrl] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(Boolean(path));
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    if (!path) {
      setObjectUrl(null);
      setIsLoading(false);
      setHasError(false);
      return;
    }

    let isMounted = true;
    let currentObjectUrl: string | null = null;

    const loadFile = async () => {
      setIsLoading(true);
      setHasError(false);

      try {
        currentObjectUrl = await storageService.createObjectUrl(path);

        if (!isMounted) {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
          }
          return;
        }

        setObjectUrl(currentObjectUrl);
      } catch (error) {
        console.error('Error fetching protected storage file:', error);
        if (isMounted) {
          setObjectUrl(null);
          setHasError(true);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadFile();

    return () => {
      isMounted = false;
      if (currentObjectUrl) {
        URL.revokeObjectURL(currentObjectUrl);
      }
    };
  }, [path]);

  return {
    objectUrl,
    isLoading,
    hasError,
  };
};
